import React, { useMemo, useEffect, useState } from 'react';
import { RiCloseLine } from 'react-icons/ri';
import { Table, Container } from './styles';

const FilterComponent = ({ filterText, onFilter, onClear, searchPlaceHolder }) => (
  <div style={{ position: 'relative', width: '100%', display: 'inline-flex', alignItems: 'center' }}>
    <input
      id="search"
      type="text"
      placeholder={searchPlaceHolder}
      value={filterText}
      onChange={onFilter}
      style={{ width: '100%', paddingRight: '40px' }}
    />
    {filterText.length > 0 ? (
      <div
        className="limpa-buscar"
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          height: '100%'
        }}
        onClick={onClear}
      >
        <RiCloseLine size={25} />
      </div>
    ) : null}
  </div>
);

const DataTable = ({
  data = [],
  columns,
  searchPlaceHolder,
  paginationServer = false,
  totalRows = 0,
  isLoading = false,
  onChangePage,
  onChangeRowsPerPage,
  onSearch,
  columnFilter
}) => {
  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  useEffect(() => {
    if (onSearch) {
      onSearch(filterText);
    }
  }, [filterText, onSearch]);

  const handleClear = () => {
    setFilterText('');
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
          setResetPaginationToggle(!resetPaginationToggle);
        }}
        onClear={handleClear}
        filterText={filterText}
        searchPlaceHolder={searchPlaceHolder}
      />
    );
  }, [filterText, searchPlaceHolder, resetPaginationToggle]);

  // Client-side filtering when paginationServer is false
  const filteredData = useMemo(() => {
    if (paginationServer || !filterText || !data) return data;

    return data.filter((item) => {
      if (!columnFilter) return true;

      if (Array.isArray(columnFilter)) {
        return columnFilter.some((field) => {
          const val = item[field];
          return val !== undefined && val !== null && val.toString().toLowerCase().includes(filterText.toLowerCase());
        });
      }

      const val = item[columnFilter];
      return val !== undefined && val !== null && val.toString().toLowerCase().includes(filterText.toLowerCase());
    });
  }, [data, filterText, columnFilter, paginationServer]);

  return (
    <Container>
      <Table
        data={filteredData}
        columns={columns}
        progressPending={isLoading}
        subHeader={true}
        noHeader={true}
        subHeaderComponent={subHeaderComponentMemo}
        theme="solarized"
        pagination={true}
        paginationServer={paginationServer}
        paginationTotalRows={paginationServer ? totalRows : filteredData.length}
        paginationResetDefaultPage={resetPaginationToggle}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </Container>
  );
};

export default DataTable;
